module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-touch', {
    staticClass: "week-container"
  }, [_c('div', {
    staticClass: "header box-shadow"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.calRangeView))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))]), _vm._v(" "), _c('v-touch', {
    staticClass: "close",
    on: {
      "tap": _vm.close
    }
  }, [_c('div', {
    staticClass: "font-large close-tap"
  }, [_c('span', {
    staticClass: "icon-cross2 pointer"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "body"
  }, [_c('weekplan', {
    staticClass: "weekplan-container",
    attrs: {
      "calId": _vm.calId,
      "date": _vm.date,
      "events": _vm.events,
      "weeknote": _vm.weeknote
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e49ff2d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/WeekPlan/Container.vue
// module id = 1642
// module chunks = 1